// @mui
import Box, { BoxProps } from '@mui/material/Box';
// hooks
import { useResponsive } from '@/hooks/ui/use-responsive';
// components
import { useSettingsContext } from '@/components/layout/settings';
//
import { NAV, HEADER } from '../config-layout';

// ----------------------------------------------------------------------

export default function Main({ children, sx, ...other }: BoxProps) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: `${HEADER.H_MOBILE + 16}px`,
          pb: 8,
          ...(lgUp && {
            pt: `${HEADER.H_MOBILE * 2 + 32}px`,
            pb: 12,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        pt: `${HEADER.H_MOBILE + 8}px`,
        ...(lgUp && {
          pt: `${HEADER.H_DESKTOP + 10}px`,
          width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
